










import { Vue, Component } from 'vue-property-decorator';
import InformesGeneradosConecta from '@/pantallas/Conecta/ReportesConecta/informesGeneradorConecta.vue';

@Component({
  components: { InformesGeneradosConecta },
})
export default class ReportesConecta extends Vue {}
